// extracted by mini-css-extract-plugin
export default {"container":"shop_container__mpw03","newQuizzesContainer":"shop_newQuizzesContainer__QLpKN","textDraw":"shop_textDraw__ln0AC"};